export const PLAYBACK_SPEEDS = [0.5, 0.75, 1, 1.25, 1.5] as const;

export const NORMAL_SPEED = 1;

export const MIN_PLAYBACK_SPEED = Math.min(...PLAYBACK_SPEEDS);

export const MAX_PLAYBACK_SPEED = Math.max(...PLAYBACK_SPEEDS);
